import gql from 'graphql-tag';

export const JupyterSandboxCourseRetrievePractice = gql`
  mutation JupyterSandboxCourseRetrievePractice($courseId: String!) {
    jupyterSandboxCourseRetrievePractice(courseId: $courseId) {
      id
    }
  }
`;

export const JupyterSandboxUserRetrievePractice = gql`
  mutation JupyterSandboxUserRetrievePractice {
    jupyterSandboxUserRetrievePractice(contentId: "clepub", expireIn: 3600) {
      id
    }
  }
`;

export const JupyterSandboxPracticeCopyFiles = gql`
  mutation JupyterSandboxPracticeCopyFiles($files: [String!]!, $id: String!, $fromId: String!) {
    jupyterSandboxPracticeCopyFiles(files: $files, id: $id, fromId: $fromId) {
      file
      copied
    }
  }
`;

export const JupyterSandboxPracticeLogin = gql`
  query JupyterSandboxPractice($id: String!, $path: String!) {
    jupyterSandboxPractice(id: $id) {
      id
      loginUrl(path: $path)
    }
  }
`;

export const JupyterSandboxPracticeTerminate = gql`
  mutation JupyterSandboxTerminatePractice($id: String!) {
    jupyterSandboxTerminatePractice(id: $id) {
      id
    }
  }
`;
